import React, { useState } from "react";
import {
  Form,
  Checkbox,
  Modal,
  Layout,
  Button,
  Input,
  Divider,
  message,
} from "antd";
//语言切换
import intl from "react-intl-universal";
//react文件预览支持docx，xlsx
import FileViewer from "react-file-viewer";
import ErCode from "@/components/erCode";
import { changePasswordByToken, forgotPassword } from "@services/auth";
import { isPhoneOrEmail } from "@/utils/utils";
import { messageModal } from "@utils/message-modal";
import "./index.less";
import PubSub from "pubsub-js";
const { Content } = Layout;

export default function LoginInput(props) {
  const { currentKey, loginFun, registerFun,openAgreeMentFather,agreeFlag,onChangeModal } = props;
  const [form] = Form.useForm();
  const [forgetPasswordForm] = Form.useForm(); // 忘记密码表单
  const [restPasswordForm] = Form.useForm(); // 重置密码
  const [agreeInter, setAgreeInter] = useState(null); // 服务协议定时器
  const [forgetPassword, setCloseChangeModal] = useState(false); // 忘记密码弹窗开关
  const [resetPassword, setResetPassword] = useState(false); // 重置密码弹窗
  const [resetPasswordMess, setResetPasswordMess] = useState(false); // 重置密码信息
  const [countSpecal, setCountSpecal] = useState(1);

  // 服务协议
  const openAgreeMent = (e) => {
    openAgreeMentFather(e)
    console.log(agreeFlag)
  };

  // 登录
  const onFinish = (values) => {
    if (currentKey == 1 || currentKey == 2) {
      if (!agreeFlag) {
        message.warning(intl.get("0e3e725b-0d51-2d8c-bfb2-e47a63b2a9c9"));
        return;
      }
    }
    loginFun(values);
  };

  // 忘记密码下一步
  const forgetPasswordSub = (value) => {
    if (!value.verifyCode) {
      message.error(
        intl.get(
          "Please_enter_the_verification_code_fe7d2bae-6b48-23f9-aee7-9dde14986a39"
        )
      );
      return;
    }

    setResetPasswordMess(value);
    PubSub.publish("erCodeState", value);
  };

  const nextStep = (isTrue) => {
    console.log(isTrue);
    if (isTrue) {
      setCloseChangeModal(false);
      setResetPassword(true);
      closeWindow();
    }
  };

  // 确认重置
  const resetPasswordSubmit = (value) => {
    resetPasswordMess.registMethod = isPhoneOrEmail(
      resetPasswordMess.phoneEmail
    );
    resetPasswordMess.account = resetPasswordMess.phoneEmail;
    forgotPassword({
      password: value.password,
      ...resetPasswordMess,
    }).then((res) => {
      if (res.code === 0) {
        setResetPassword(false);
        message.success(res.message);
      } else {
        message.error(res.message);
        return false;
      }
    });
  };


  // 关闭弹窗
  const closeWindow = () => {
    setCloseChangeModal(false);
    // setResetPassword(false);
    forgetPasswordForm.resetFields();
    restPasswordForm.resetFields();
    setCountSpecal(countSpecal + 1);
    PubSub.unsubscribe("erCodeState");
  };

  return (
    <>
      <Form
        form={form}
        name="basic"
        onFinish={onFinish}
        className="login-main"
        autoComplete="off"
      >
        <Form.Item
          name="username"
          label={intl.get("Account_9c2bb8e4-91fa-2d8d-a5e9-40c10fe68de7")}
          rules={[
            {
              required: true,
              message: intl.get("8de9aef0-6797-23ec-ac4e-1a76f19464ff"),
            },
          ]}
        >
          <Input
            size="large"
            placeholder={intl.get("8de9aef0-6797-23ec-ac4e-1a76f19464ff")}
          />
        </Form.Item>

        <Form.Item
          name="password"
          label={intl.get("Password_53aeeeeb-f4b2-2ec7-8378-0824b54674f2")}
          rules={[
            {
              required: true,
              message: intl.get(
                "Password_e20ad08a-94e5-2741-8abc-622d44e1ef0d_Password"
              ),
            },
          ]}
        >
          <Input.Password
            size="large"
            placeholder={intl.get(
              "Password_e20ad08a-94e5-2741-8abc-622d44e1ef0d_Password"
            )}
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" block htmlType="submit" size="large">
            {intl.get("Login_7b3caf4e-b296-2437-9bb8-b25c327406d8")}
          </Button>
        </Form.Item>
        {currentKey == 1 || currentKey == 2 ? (
          <div>
            <Form.Item className="login-read">
              <Checkbox
                checked={agreeFlag}
                onChange={(e, i) => {
                  onChangeModal("login", e, i);
                }}
              >
                {intl.get("Read_agreeed_1f509815-fe90-291d-a8b5-a4ce092c8739")}
                <span className="login-read-serve" onClick={openAgreeMent}>
                  {currentKey == 1
                    ? intl.get(
                        "Speechocean_Service_agreement_877db9c4-062c-2fe7-8f57-3be9dd4a4092"
                      )
                    : intl.get(
                        "Team_agreement_877db9c4-062c-2fe7-8f57-3be9dd4a4092"
                      )}
                </span>
              </Checkbox>
            </Form.Item>
            <Divider />
            <Form.Item className="login-reg">
              <span>
                {intl.get("No_account_def78920-dd43-2cf3-ba84-648051d86746")}
                <span
                  className="login-reg-register"
                  onClick={() => {
                    registerFun(1);
                  }}
                >
                  {intl.get("Create_one_8d829590-c95d-2efd-b0b0-89efd94ce07d")}
                </span>
              </span>
              <span
                className="login-reg-forget"
                onClick={(e) => {
                  setCloseChangeModal(true);
                }}
              >
                {intl.get(
                  "Forgot_password_d9f2a6f1-a07c-2247-a330-49e9ee3e381e"
                )}
              </span>
            </Form.Item>
          </div>
        ) : (
          ""
        )}

        {currentKey == 3 ? (
          <Form.Item className="login-reg">
            <span
              className="login-reg-forget"
              onClick={(e) => {
                setCloseChangeModal(true);
              }}
            >
              {intl.get("Forgot_password_d9f2a6f1-a07c-2247-a330-49e9ee3e381e")}
            </span>
          </Form.Item>
        ) : (
          ""
        )}
      </Form>

      {/* 忘记密码 */}
      <Modal
        className="forget-password"
        title=""
        centered
        visible={forgetPassword}
        footer={false}
        closable={false}
        maskClosable={false}
      >
        <div className="forget-password-top">
          <p onClick={closeWindow}>
            &lt; {intl.get("89827152-6473-2594-bbe6-8786be5385bf")}
          </p>
          <p>
            {intl.get("Forgot_password_d9f2a6f1-a07c-2247-a330-49e9ee3e381e")}
          </p>
          <p>{intl.get("5b7a9f04-84ff-2875-bffc-62c9f731d49c")}</p>
        </div>
        <Form
          form={forgetPasswordForm}
          onFinish={forgetPasswordSub}
          labelWrap
          labelAlign="left"
        >
          <ErCode
            type={0}
            isCheck={true}
            countSpecal={countSpecal}
            nextStep={nextStep}
            isForget={true}
            forms={forgetPasswordForm}
          />
          <Form.Item className="forget-password-btn">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              className="themeBgColor"
            >
              {intl.get("Next_7d758f4b-5509-2946-b7a8-d61384998d77")}
            </Button>
            <Button size="large" onClick={closeWindow}>
              {intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      {/* 重置密码 */}
      <Modal
        title=""
        visible={resetPassword}
        onCancel={() => {
          setResetPassword(false);
        }}
        className="reset-password"
        centered
        closable={false}
        maskClosable={false}
        footer={false}
      >
        <div className="forget-password-top">
          <p onClick={closeWindow}>
            &lt; {intl.get("89827152-6473-2594-bbe6-8786be5385bf")}
          </p>
          <p>
            {intl.get("Reset_password_98bd11c5-6666-2351-a11b-847fb910f92d")}
          </p>
          <p>
            {intl.get("Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb")}
          </p>
        </div>
        <Form
          form={restPasswordForm}
          onFinish={resetPasswordSubmit}
          labelWrap
          labelAlign="left"
        >
          <Form.Item
            label={intl.get("Password_53aeeeeb-f4b2-2ec7-8378-0824b54674f2")}
            name="password"
            hasFeedback
            rules={[
              {
                required: true,
                message: intl.get(
                  "Password_e20ad08a-94e5-2741-8abc-622d44e1ef0d_Password"
                ),
              },
              {
                pattern: new RegExp(
                  /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
                ),
                message: intl.get(
                  "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb"
                ),
              },
            ]}
          >
            <Input.Password
              size="large"
              placeholder={intl.get(
                "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb"
              )}
            />
          </Form.Item>
          <Form.Item
            label={intl.get(
              "Confirm_password_c11a821c-0a36-263d-a77a-30097899f35e"
            )}
            name="passwordConfirm"
            dependencies={["password"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: intl.get(
                  "Password_e20ad08a-94e5-2741-8abc-622d44e1ef0d_Password"
                ),
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error(
                      intl.get(
                        "The_passwords_entered_twice_do_not_match_8613bcda-26a3-2814-95fc-027239abaee3"
                      )
                    )
                  );
                },
              }),
            ]}
          >
            <Input.Password
              size="large"
              placeholder={intl.get(
                "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb"
              )}
            />
          </Form.Item>
          <Form.Item className="forget-password-btn">
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              className="themeBgColor"
            >
              {intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19")}
            </Button>
            <Button
              size="large"
              onClick={() => {
                setResetPassword(false);
                restPasswordForm.resetFields();
              }}
            >
              {intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
